import { withRouter } from 'react-router-dom';
import BaseDados from '../../base/testes/BaseDados';

class Dados extends BaseDados {

}

export default withRouter(Dados);
